import { Pipe, PipeTransform } from '@angular/core';
import { FeaturesI18N } from '../lib/base/model/features-i18n';

@Pipe({ name: 'i18n' })
export class I18NPipe implements PipeTransform {
  transform(value: string): string {
    return FeaturesI18N.getString(value);
  }
}
